var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplateicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7231_9117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3V8C1.25 8.9665 2.0335 9.75 3 9.75H33C33.9665 9.75 34.75 8.9665 34.75 8V3C34.75 2.0335 33.9665 1.25 33 1.25H3C2.0335 1.25 1.25 2.0335 1.25 3ZM3 34.75H8.2C9.1665 34.75 9.95 33.9665 9.95 33L9.95 17C9.95 16.0335 9.1665 15.25 8.2 15.25H3C2.0335 15.25 1.25 16.0335 1.25 17L1.25 33C1.25 33.9665 2.0335 34.75 3 34.75ZM18 34.75H32.8C33.7665 34.75 34.55 33.9665 34.55 33V17C34.55 16.0335 33.7665 15.25 32.8 15.25L18 15.25C17.0335 15.25 16.25 16.0335 16.25 17L16.25 33C16.25 33.9665 17.0335 34.75 18 34.75Z",
    stroke: "#1D4842",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7231_9117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateicon);
export default __webpack_public_path__ + "static/media/templateicon.fb293e0dbb43c3892f538a18a26aba9b.svg";
export { ForwardRef as ReactComponent };